<script>

    import { toast } from 'bulma-toast'
    import { fixedpricesStore, modalStore, notifyStore, userStore, adminStore } from '../stores'

    import FixedpricesService from '../$services/fixedprices.service'
    import DateMethod from '../$methods/date.method'
    import TranslateMethods from '../$methods/translate.methods'

    import Pagination from '../$components/pagination.svelte'
    import Table from '../$components/table.svelte'
    import Button from '../$components/button.svelte'
    import ButtonModal from '../$components/button.modal.svelte'
    import Users from '../$components/select.users.svelte'
    
    import Providers from '../$components/providers.svelte'
    import Report from './component.report.svelte'

    $: $notifyStore === 'fixedprices_updated' && getFixedprices()

    export let showUsers = false
    export let query = {
        page: 0,
        userId: $userStore? $userStore._id : null,
        adminId: $adminStore._id
    }

    let metadata = {}
    let loading = false

    getFixedprices()

    async function getFixedprices(reset = false) {

        if(reset === true)
            query.page = 0

        loading = true
        const resp = await FixedpricesService.getFixedprices(query)
        loading = false

        if(!resp.success)
            return toast({ message: resp.error.message, type: 'is-danger' })

        fixedpricesStore.set(resp.data.fixedprices)
        metadata = resp.data.metadata
        notifyStore.set(null)
    }

</script>

<Table items={$fixedpricesStore.length} total={metadata.total} {loading}>
    <div slot="toolbar">
        <div class="columns is-multiline is-align-items-flex-end mb-0">
            {#if showUsers}
                <div class="column">
                    <Users bind:userId={query.userId} on:select={() => getFixedprices(true)} hideLabel />
                </div>
            {/if}
            <div class="column is-narrow">
                <Providers
                    on:change={() => getFixedprices(true)}
                    bind:provider={query.provider}
                    bind:service={query.service}
                    isDefault={false}
                    hideLabel />
            </div>
            <div class="column is-narrow">
                <div class="fixedprices-toolbar-actions">
                    {#if !$userStore && $adminStore.role === 'admin'}
                        <Report />
                        <ButtonModal modalId="fixedprice_upload_modal" text="Subir" icon="upload" />
                    {/if}
                    <ButtonModal modalId="fixedprice_create_modal" text="Agregar" icon="plus" />
                </div>
            </div>
        </div>
    </div>
    <div slot="footer">
        <Pagination bind:metadata bind:page={query.page} on:change={getFixedprices} />
    </div>
    <thead>
        <tr>
            <th>#</th>
            {#if showUsers}
                <th>Usuario</th>
            {/if}
            <th>Estatus</th>
            <th>Proveedor</th>
            <th>Servicio</th>
            <th class="has-text-right">Precio</th>
            <th>Rango</th>
            <th class="has-text-right">Expira</th>
            <th class="has-text-right">Acciones</th>
        </tr>
    </thead>
    <tbody>
        {#each $fixedpricesStore as fixedprice, index}
            <tr>
                <td>{(metadata.items * query.page) + (index + 1)}</td>
                {#if showUsers}
                    <td>
                        <div>
                            <div>{fixedprice.user.name}</div>
                            <div>{fixedprice.user.email}</div>
                        </div>
                    </td>
                {/if}
                <td>{DateMethod.isAfter(fixedprice.expired) ? 'Activo' : 'Expiró'}</td>
                <td>{fixedprice.provider}</td>
                <td>{fixedprice.service}</td>
                <td class="has-text-right">{TranslateMethods.get(fixedprice.setPrice)}</td>
                <td>{fixedprice.volumetricMin} kg a {fixedprice.volumetricMax} kg</td>
                <td class="has-text-right">{DateMethod.dateLarge(fixedprice.expired)}</td>
                <td>
                    <Button on:click={() => modalStore.open('fixedprice', 'modal', fixedprice)} icon="ellipsis-v" />
                </td>
            </tr>
        {/each}
    </tbody>
</Table>